import { SignalRContext } from 'context/signalr';

export const { useSignalREffect } = SignalRContext;
